<template>
  <div>
    <breadcrumb-component
        :mainTitle="'My Account'"
        :moduleTitle="'Vlan Cloud'"
        :subTitle="'My Account'"
    />
    <div class="row">
      <div class="col-md-12">
        <div class="card card_full_window vc_account_page ">
          <div class="card-body">
            <div class="common_content_wrap no_left_content">
              <h5 class="common_subtitle pb_15 border-lightgray-bottom mb_0">My Account Area</h5>
              <div v-if="hasPermission" class="common_tab_list">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <template v-for="tab in tabs" :key="`tab_${tab.slug}`">
                    <li
                        v-if="!tab.permission || can(tab.permission)"
                        role="presentation"
                        class="nav-item"
                        :class="{active: selectedTab === tab.slug}"
                        @click="selectTab(tab.slug)"
                    >
                      <button
                          class="nav-link"
                          :class="{active: selectedTab === tab.slug}"
                          id="Account-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#Account-tab-pane"
                          type="button"
                          role="tab"
                          aria-controls="Account-tab-pane"
                          :aria-selected="{active: selectedTab === tab.slug}"
                      >
                        {{ tab.name }}
                      </button>
                    </li>
                  </template>
                </ul>
              </div>
              <div v-else>
                <p>You do not have permission to view this content.</p>
              </div>
              <div v-if="hasPermission" class="common_tab_content">
                <div class="tab-content" id="myTabContent">
                  <div class="tab-pane fade show active" id="Account-tab-pane" role="tabpanel" aria-labelledby="Account-tab" tabindex="0">
                    <div class="my_account_content">
                      <component
                          :is="selectedComponent"
                          :selectedTab="selectedTab"
                      >
                      </component>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {shallowRef} from "vue";
import BreadcrumbComponent from "@/components/shared/BreadcrumbComponent.vue";
import MyAccount from "@/views/account/MyAccount.vue";
import MyService from "@/views/account/MyService.vue";
import PaymentCost from "@/views/account/PaymentCost.vue";
import {useAbility} from "@casl/vue";
// import SecurityCredential from "@/views/account/SecurityCredential .vue";
// import MyCoupon from "@/views/account/MyCoupon.vue";

export default{
  name: "ManageAccountIndex",
  components: {BreadcrumbComponent},
  props: ['slug'],
  data() {
    return {
      tabs: [
        { id: 1, name: 'My Account', slug: 'my-account', component: shallowRef(MyAccount), permission: 'my_account' },
        { id: 3, name: 'My Service', slug: 'my-service', component: shallowRef(MyService), permission: 'my_service' },
        { id: 4, name: 'Payment & Cost', slug: 'payment-cost', component: shallowRef(PaymentCost), permission: 'payment_cost' },
        // { id: 5, name: 'Security Credential', slug: 'security-credential', component: shallowRef(SecurityCredential) },
        // { id: 6, name: 'My Coupon', slug: 'my-coupon', component: shallowRef(MyCoupon) },
      ],
      selectedTab: 'my-account',
    }
  },
  computed: {
    selectedComponent() {
      return this.tabs.find(el => el.slug === this.selectedTab).component;
    },
    hasPermission() {
      return this.tabs.some(tab => !tab.permission || this.can(tab.permission));
    }
  },
  watch: {
    $route() {
      // Watch the route change to update the selected tab
      this.selectedTab = this.getTabFromRoute();
    }
  },
  created() {
    this.selectedTab = this.getTabFromRoute();
  },
  methods: {
    selectTab(selectedTab) {
      this.selectedTab = selectedTab;
      this.$router.push({ name: 'manage_account', params: { slug: selectedTab } });
    },
    getTabFromRoute() {
      const tabSlug = this.slug;
      return this.tabs.some(tab => tab.slug === tabSlug) ? tabSlug : this.selectedTab;
    },
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
}
</script>
<style scoped>

</style>